module.exports = __webpack_public_path__ + "static/media/logo8.14bab8f5.png";